import { render, staticRenderFns } from "./SmsList.vue?vue&type=template&id=4b94a040&scoped=true"
import script from "./SmsList.vue?vue&type=script&lang=js"
export * from "./SmsList.vue?vue&type=script&lang=js"
import style0 from "./SmsList.vue?vue&type=style&index=0&id=4b94a040&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b94a040",
  null
  
)

export default component.exports